<script lang="ts">
    
    import type { Route } from "../global";
    import RouteMeta from "./RouteMeta.svelte";

    export let route: Route;

</script>

<div class="route-slide">
    <h3 class="name">{route.name}</h3>
    <div class="meta">
        <RouteMeta {route} />
    </div>
</div>

<style lang="scss">

    @use '../variables';

    .name {
        border: 3px solid #12B1A8;
        background-color: #fff;
        color: #104994;
        text-align: center;
        padding: 0.5rem;
        border-radius: 1rem;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 1rem;

        @media (min-width: 500px) {
            font-size: 1.3rem;
        }
    }

</style>
